<template>
  <div class="factura-proforma-datos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información de la Factura">
          <b-table 
              small 
              responsive="sm" 
              :items="facturaProformaDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Ordenes de Trabajo">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="facturaProformaRenglonesDatos" 
              :fields="fieldsRenglones">
            <template v-slot:cell(importeNeto)="data">
              {{ data.item.importeNeto | moneda(facturaProformaDatosMoneda) }}
            </template>
            <template v-slot:cell(pjeFacturado)="data">
              {{ data.item.pjeFacturado | porcentaje }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(facturaProformaDatosMoneda) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Información de Impresión">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="facturaProformaRenglonesDescripcionDatos" 
              :fields="fieldsRenglonesDescripcion">
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(facturaProformaDatosMoneda) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'facturaProforma/getField',
  mutationType: 'facturaProforma/updateField',
});

export default {
  name: 'FacturaProformaData',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      facturaProformaId: 0,

      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      fieldsRenglones: [
        {
          key: 'rubroTrabajo',
          label: 'Rubro'
        },
        { key: 'titulo' },
        // { key: 'descripcion' },
        {
          key: 'importeNeto',
          label: 'Cotización',
          class: "text-right",
        },
        {
          key: 'pjeFacturado',
          label: 'Pje. Facturado',
          class: "text-right",
        },
        {
          key: 'importe',
          class: "text-right",
        },
      ],

      fieldsRenglonesDescripcion: [
        {
          key: 'descripcion',
          label: 'Descripción'
        },
        {
          key: 'importe',
          class: "text-right",
        },
      ],

      tableBusy: false,
      labelCols: 2
    }
  },
  created() {
    this.facturaProformaId = this.$route.params.id;

    this.showSpinner();
    this.$store.dispatch('facturaProforma/getDatos', this.facturaProformaId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  computed: {
    ...mapFields([
      'facturaProformaDatos',
      'facturaProformaRenglonesDatos',
      'facturaProformaRenglonesDescripcionDatos',
      'facturaProformaDatosMoneda'
    ]),
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>

<style>
  .factura-proforma-datos .registro-ordenes table td {
    vertical-align: middle;
    border: none;
  }
  .factura-proforma-datos .registro-ordenes table td[aria-colindex="1"] {
    width: 35%;
  }
  .factura-proforma-datos .registro-ordenes table td[aria-colindex="2"] {
    width: 35%;
  }
  .factura-proforma-datos .registro-ordenes table td[aria-colindex="3"],
  .factura-proforma-datos .registro-ordenes table td[aria-colindex="4"],
  .factura-proforma-datos .registro-ordenes table td[aria-colindex="5"] {
    width: 10%;
  }
</style>
